import React from 'react';

type Props = {
  className?: string;
};

const FSRHighlights: React.FC<Props> = ({ className }) => {
  return (
    <>
      <div className={`bg-gray-100 ${className}`}>
        <div className="max-w-7xl py-4  lg:py-24 ">
          <dl className="mt-12 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 lg:grid-cols-4 lg:gap-x-8">
            <div className="flex">
              <svg
                className="flex-shrink-0 h-6 w-6 text-primary-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                />
              </svg>

              <div className="ml-3">
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  Contactless dining
                </dt>
                <dd className="mt-2 text-base text-gray-500">
                  <a
                    id={'SqZj85'}
                    className={'text-primary-600 hover:text-primary-700'}
                    href={'/product?ref=product_overview_SqZj85_inline#safety'}
                    onClick={e => {
                      // e.preventDefault();
                      // @ts-ignore
                      analytics.track('Safety Clicked', {
                        title: 'protect_your_staff_and_guests',
                        action: 'click',
                        location: 'fsr_highlights',
                        destination: 'product_safety',
                      });
                      // history.push('/use-cases/fsr#margin-impact?ref=home_product_aoBx9N_inline')
                    }}
                  >
                    Protect your staff and guests
                  </a>{' '}
                  without compromising service.
                </dd>
              </div>
            </div>

            <div className="flex">
              <svg
                className="flex-shrink-0 h-6 w-6  text-primary-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                />
              </svg>
              <div className="ml-3">
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  Improve your margins
                </dt>
                <dd className="mt-2 text-base text-gray-500">
                  Maintain a{' '}
                  <a
                    id={'585T1j'}
                    className={'text-primary-600 hover:text-primary-700'}
                    href={
                      '/use-cases/fsr?ref=product_overview_585T1j_inline#margin-impact'
                    }
                    onClick={e => {
                      // e.preventDefault();
                      // @ts-ignore
                      analytics.track('Impact Clicked', {
                        title: 'lean_and_flexible',
                        action: 'click',
                        location: 'fsr_highlights',
                        destination: 'fsr_impact',
                      });
                      // history.push('/use-cases/fsr#margin-impact?ref=home_product_aoBx9N_inline')
                    }}
                  >
                    {' '}
                    lean and flexible{' '}
                  </a>{' '}
                  operation while making{' '}
                  <a
                    id={'F4cWCw'}
                    className={'text-primary-600 hover:text-primary-700'}
                    href={
                      '/use-cases/fsr?ref=product_overview_F4cWCw_inline#margin-impact'
                    }
                    onClick={e => {
                      // e.preventDefault();
                      // @ts-ignore
                      analytics.track('Impact Clicked', {
                        title: 'more_in_profits',
                        action: 'click',
                        location: 'fsr_highlights',
                        destination: 'fsr_impact',
                      });
                      // history.push('/use-cases/fsr#margin-impact?ref=home_product_aoBx9N_inline')
                    }}
                  >
                    {' '}
                    more in profits
                  </a>
                  .
                </dd>
              </div>
            </div>

            <div className="flex">
              <svg
                className="flex-shrink-0 h-6 w-6  text-primary-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
                />
              </svg>

              <div className="ml-3">
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  Fit to your workflow
                </dt>
                <dd className="mt-2 text-base text-gray-500">
                  Use us as a{' '}
                  <a
                    id={'j0rt2k'}
                    className={'text-primary-600 hover:text-primary-700'}
                    href={
                      '/product?ref=product_overview_j0rt2k_inline#workflow'
                    }
                    onClick={e => {
                      // e.preventDefault();
                      // @ts-ignore
                      analytics.track('Workflow Clicked', {
                        title: 'standalone_product',
                        action: 'click',
                        location: 'fsr_highlights',
                        destination: 'fsr_workflow',
                      });
                      // history.push('/use-cases/fsr#margin-impact?ref=home_product_aoBx9N_inline')
                    }}
                  >
                    {' '}
                    standalone product{' '}
                  </a>{' '}
                  or one that works with your
                  <a
                    id={'6F5yq8'}
                    className={'text-primary-600 hover:text-primary-700'}
                    href={
                      '/product?ref=product_overview_6F5yq8_inline#workflow'
                    }
                    onClick={e => {
                      // e.preventDefault();
                      // @ts-ignore
                      analytics.track('Workflow Clicked', {
                        title: 'existing_workflow',
                        action: 'click',
                        location: 'fsr_highlights',
                        destination: 'fsr_workflow',
                      });
                      // history.push('/use-cases/fsr#margin-impact?ref=home_product_aoBx9N_inline')
                    }}
                  >
                    {' '}
                    existing workflow
                  </a>
                  .
                </dd>
              </div>
            </div>

            <div className="flex">
              <svg
                className="flex-shrink-0 h-6 w-6  text-primary-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>

              <div className="ml-3">
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  Get started in minutes
                </dt>
                <dd className="mt-2 text-base text-gray-500">
                  This isn't complicated - you can position yourself for success{' '}
                  <a
                    id={'1dMaVo'}
                    className={'text-primary-600 hover:text-primary-700'}
                    href={'/contact?ref=product_overview_1dMaVo_inline'}
                    onClick={e => {
                      // e.preventDefault();
                      // @ts-ignore
                      analytics.track('Contact Clicked', {
                        title: 'right_now',
                        action: 'click',
                        location: 'fsr_highlights',
                        destination: 'contact_hero',
                      });
                      // history.push('/use-cases/fsr#margin-impact?ref=home_product_aoBx9N_inline')
                    }}
                  >
                    right now
                  </a>
                  .
                </dd>
              </div>
            </div>
          </dl>
        </div>
      </div>
    </>
  );
};

export default FSRHighlights;
